import React from 'react';
import PronouncePage from '../pronounce/PronouncePage';

export default function Pronounce() {
  return <PronouncePage />;
}
